import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sCompetition = _resolveComponent("sCompetition")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: `Mis pruebas ${_ctx.titleModal}`,
    modelValue: _ctx.gblDialogTest,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gblDialogTest) = $event)),
    class: "bg-light",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    top: "2vh"
  }, {
    default: _withCtx(() => [
      (_ctx.gblDialogTest)
        ? (_openBlock(), _createBlock(_component_sCompetition, {
            key: 0,
            ref: "childComponentRef",
            idacrd: _ctx.rowAcrd?.idacreditation,
            idevent: _ctx.rowAcrd?.idevent,
            idsport: _ctx.rowAcrd?.idsport
          }, null, 8, ["idacrd", "idevent", "idsport"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}